module.exports = __webpack_public_path__ + "static/img/unknown-error.46039e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/unknown-error.png
// module id = ck8i
// module chunks = 6